import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
    HomePage,
    BookedPage
} from '../pages';

import { ApplicationRoles } from '../../helpers';

// Looking for an icon name?
// look here! https://material-ui.com/components/material-icons/
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PeopleAltIcon from '@material-ui/icons/PeopleAltOutlined';
import LayersIcon from '@material-ui/icons/LayersOutlined';
import DescriptionIcon from '@material-ui/icons/Description';

export const NavRoutes = {

    Home: "/",
    Forbidden: "/forbidden",
    NotFound: "/notfound",
    Login: "/login",
    Booked: "/booked"
};

export const NavContext = React.createContext(null);

const { Provider } = NavContext;
export const NavProvider = ({ ...props }) => {
    const history = useHistory();

    const navigateTo = (route, args) => {
        route = compileRoute(route, args);
        history.push(route);
    }

    const switchTo = (route, args) => {
        route = compileRoute(route, args);
        history.replace(route);
    }

    const getRouteTo = (route, args) => {
        route = compileRoute(route, args);
        return route;
    }

    const goBack = () => {
        history.goBack();
    }

    const compileRoute = (route, args) => {
        if (route.includes(":") && args && args.length > 0) {
            for (let i = 0; i < args.length; i++) {
                let startIndex = route.indexOf(":", 0);
                if (startIndex === -1) break;
                let endIndex = route.indexOf("/", startIndex);
                if (endIndex === -1) endIndex = route.length - 1;
                else endIndex--;
                const token = route.substr(startIndex, (endIndex - startIndex) + 1);
                route = route.replace(token, args[i]);
            }
        }

        return route;
    }

    const getAllRoutes = (source) => {

        const getRoutes = (src, lst) => {
            const keys = Object.keys(src);
            for (let index in keys) {
                const key = keys[index];
                if (typeof src[key] === "string") {
                    lst.push(src[key]);
                } else {
                    getRoutes(src[key], lst);
                }
            }
        }

        const list = [];
        getRoutes(source, list);
        return list;
    }

    const [allRoutes, setAllRoutes] = useState(getAllRoutes(NavRoutes));

    const [menuItems, setMenuItems] = useState([]);

    return (
        <Provider value={{
            allRoutes,
            menuItems,
            navigateTo,
            switchTo,
            getRouteTo,
            goBack
        }}>
            {props.children}
        </Provider>
    );
}